import { OpenInNewWindowIcon } from '@radix-ui/react-icons';

import { Button } from '../../primitives/button';

import type { JSX } from 'react';

interface ButtonExternalLinkProps extends React.ComponentPropsWithoutRef<typeof Button> {
  icon?: JSX.Element;
  url: string;
}

export function ButtonExternalLink({
  icon = <OpenInNewWindowIcon className="size-4" />,
  url,
  onClick, // remove callback
  ...props
}: ButtonExternalLinkProps) {
  return (
    <Button asChild {...props}>
      <a href={url} target="_blank" rel="noopener noreferrer">
        {icon}
      </a>
    </Button>
  );
}
